class RequestQueue {
  private queue: Array<() => Promise<any>> = [];
  private running = 0;
  private maxConcurrent = 4;

  async add<T>(requestFn: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.queue.push(async () => {
        try {
          const result = await requestFn();
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });

      this.processQueue();
    });
  }

  private async processQueue() {
    if (this.running >= this.maxConcurrent || this.queue.length === 0) {
      return;
    }

    this.running++;
    const requestFn = this.queue.shift();

    if (requestFn) {
      try {
        await requestFn();
      } catch (error) {
        console.error('Request queue error:', error);
      } finally {
        this.running--;
        this.processQueue();
      }
    }
  }

  getStatus() {
    return {
      running: this.running,
      queued: this.queue.length,
      maxConcurrent: this.maxConcurrent,
    };
  }

  setMaxConcurrent(max: number) {
    this.maxConcurrent = max;
    this.processQueue();
  }
}

const globalObj = globalThis as any;
if (!globalObj._requestQueue) {
  globalObj._requestQueue = new RequestQueue();
}

export const globalRequestQueue: RequestQueue = globalObj._requestQueue;

export async function queuedFetch(
  url: string,
  options?: RequestInit,
): Promise<Response> {
  return globalRequestQueue.add(async () => {
    const response = await fetch(url, options);

    return response;
  });
}
